/* eslint-disable react-hooks/rules-of-hooks */
import React, {useEffect, useLayoutEffect} from 'react';
import {BackHandler, Platform} from 'react-native';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../redux';
import {useNavigation} from '@react-navigation/native';
import querystring from 'query-string';
import View from './view';
import {profileHolderVolunteerIdSelector} from '../../redux/selectors/profile';
import {Screens} from '../../shared/routing';
import {dobroruLinkSelector} from '../../redux/selectors/dobroru';
import {getDobroruData, loginDobroru} from '../../redux/actions/dobroru';
import {dobroruActions} from '../../redux/reducers/dobroru';

export const VolunteersServiceScreen: React.FC = () => {
  const navigation = useNavigation();
  const dispatch = useAppDispatch();

  const volunteerId = useSelector(profileHolderVolunteerIdSelector);
  const dobroruLink = useSelector(dobroruLinkSelector);

  if (Platform.OS === 'web') {
    if (dobroruLink) {
      window.open(dobroruLink, '_self');
      return null;
    }
  }

  useLayoutEffect(() => {
    if (Platform.OS !== 'web') return;

    const {code} = querystring.parse(window.location.search.replace('?', '')) ?? {};

    if (code && typeof code === 'string') {
      navigation.setParams({code: undefined});

      dispatch(loginDobroru(code));
    }

    return () => {
      dispatch(dobroruActions.setLink(null));
    };
  }, []);

  useLayoutEffect(() => {
    if (volunteerId) dispatch(getDobroruData());
  }, [volunteerId]);

  useEffect(() => {
    const onBackPress = () => {
      if (dobroruLink) {
        dispatch(dobroruActions.setLink(null));
        return true;
      }

      return false;
    };
    const subscription = BackHandler.addEventListener('hardwareBackPress', onBackPress);

    return () => subscription.remove();
  }, [dobroruLink]);

  return <View link={dobroruLink} gotoEvents={() => navigation.navigate(Screens.VolunteersServiceEvents)} />;
};
